declare const process: {
  env: {
    REACT_APP_API: string
    REACT_APP_GOOGLE_MAPS_API_KEY: string
  }
}

// ----------------------------------------------------------------------
// API
export const API_BASE_URL = process.env.REACT_APP_API
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
